module.exports = __webpack_public_path__ + "static/media/ovation-logo.c94dce1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/ovation-logo.png
// module id = 692
// module chunks = 0